import { styled } from '@mui/system'
import { Button, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { closeModal } from 'actions/app'
import ModalActions from 'components/modal/modal-actions'
import ModalContainer from 'components/modal/modal-container'
import ModalHeader from 'components/modal/modal-header'
import { TEST_IDS } from 'test-ids'

export default function CreateHarvestRequestSent() {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const handleClose = useCallback(() => {
    dispatch(closeModal())
  }, [])

  return (
    <StyledContainer data-testid={TEST_IDS.createHarvestRequestDialog}>
      <ModalHeader>{t('request_sent')}</ModalHeader>
      <StyledContent>
        <Typography>{t('create_harvest_request_sent')}</Typography>
      </StyledContent>
      <ModalActions>
        <Button
          variant="contained"
          onClick={handleClose}
          data-testid={TEST_IDS.createHarvestRequestCloseButton}
        >
          {t('close')}
        </Button>
      </ModalActions>
    </StyledContainer>
  )
}

const StyledContainer = styled(ModalContainer)({
  display: 'flex',
  flexDirection: 'column',
})

const StyledContent = styled('div')({
  flexGrow: 1,
})
